import { supabase } from '@/integrations/supabase/client';
import type { Database } from '@/integrations/supabase/types';

type PublicFunctions = Database['public']['Functions'];

/**
 * Type-safe RPC caller for Supabase Database Functions.
 *
 * Enforces compile-time validation of function names against Database['public']['Functions'],
 * typing arguments and return values strictly according to auto-generated Supabase types.
 */
export async function executeRpc<TFn extends keyof PublicFunctions>(
  fn: TFn,
  args?: PublicFunctions[TFn]['Args']
): Promise<PublicFunctions[TFn]['Returns']> {
  const { data, error } = await (supabase.rpc as any)(fn, args);

  if (error) {
    console.error(`[Supabase RPC Error] ${String(fn)}:`, error);
    throw error;
  }

  return data as PublicFunctions[TFn]['Returns'];
}
